




























































































































































































































































































import RouteTab from '@/components/RouteTab.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { UsersApi, OrgsApi, User, Org, AuthApi } from '../../../api';
import Toast from '@/components/display/toast.vue';
import TitleMixin from '@/mixins/title-mixin';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import HubSpotLink from '@/components/display/HubSpotLink.vue';
import InformationRow from '@/components/display/information-row.vue';
import CountryFlag from '@/components/display/CountryFlag.vue';
import * as CCLookup from 'country-code-lookup';
import PreferencesComponent from '@/pages/account/users/user/preferences.vue';

@Component({
	components: {
		RouteTab,
		Preferences: PreferencesComponent,
		RouterLinkButton,
		secondaryNav,
		Toast,
		infoTabs,
		HubSpotLink,
		InformationRow,
		CountryFlag,
	},
	mixins: [TitleMixin],
})
export default class UserView extends Vue {
	public rid = Math.random();

	public smallScreen = window.innerWidth > 1000;
	public loading = true;
	public user: any | null = null;
	public products: any[] | null = null;
	public orgProducts: any[] | null = null;
	public orgs: any[] | null = true;
	public audits: any[] | null = true;
	public billingAdminOrgs: any[] | null = true;
	public org: any | null = true;
	public roles: any[] | null = true;
	public changeLog: any[] | null = null;
	public hasPartnerOrg: boolean = false;

	public accessFields: any[] | null = [
		{ key: 'id', label: 'Id', sortable: true },
		{ key: 'name', label: 'Name', sortable: true },
		{ key: 'site.name', label: 'Site', sortable: true },
		{ key: 'type', label: 'Type', sortable: true },
		{ key: 'status', label: 'Status', sortable: true },
		{ key: 'pivot.permission', label: 'Permission', sortable: true },
		{ key: 'permission', label: 'Grade' },
		{ key: 'unlink', label: 'Unlink' },
	];

	public auditFields: any[] | null = [
		{ key: 'created_at', label: 'Date Updated' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public billingAdminFields: any[] | null = [
		{ key: 'id', label: 'Id', sortable: true },
		{ key: 'name', label: 'Organisation', sortable: true },
	];

	private simProUrl: string = process.env.VUE_APP_SIMPRO_BASE_URL + '/staff/contact.php';

	private api: UsersApi;
	private orgApi: OrgsApi;

	constructor() {
		super();
		this.api = new UsersApi();
		this.orgApi = new OrgsApi();
	}

	public pageTitle() {
		return `User | ${this.user ? this.user.name : ''}`;
	}

	public get userCountryCode(): string | null {
		return this.user?.preferences?.country ?? null;
	}

	public get countryName(): string | null {
		if (!this.userCountryCode) {
			return null;
		}
		const searchResult = CCLookup.byIso(this.userCountryCode);
		return searchResult?.country ?? null;
	}

	public clickBillingAdminOrg(item: Org, newtab: boolean, route: any) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: route,
				params: { orgId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: route,
				params: { orgId: item.id },
			} as any);
		}
	}

	public async load(doLoading: boolean = true) {
		this.setBillingAdminOrgs();
		const { userId } = this.$route.params;
		this.loading = doLoading;
		try {
			const { data } = await this.api.getUserId(parseInt(userId, 10), {
				params: {
					include:
						'org,org.products,roles,roles.org,roles.org.products,org.children,products,products.org,products.site,audits,audits.user', //
				},
			});
			this.user = data;
			this.org = data.org || {};
			this.orgs = [data.org] || {};
			this.roles = data.roles || { 'org.name': '', name: '' };
			this.products = data.products || {};
			this.audits = data.audits || {};
			this.hasPartnerOrg = data.roles.some((element, index, array) => {
				return element.name.includes('partner');
			});
		} catch (e) {
			console.log(e);
			this.user = null;
		} finally {
			this.loading = false;
		}
	}

	public async setBillingAdminOrgs() {
		const { userId } = this.$route.params;
		try {
			const filters = [{ field: 'adminId', value: userId }];
			const { data } = await this.orgApi.getOrgs({
				params: { 'filter[adminId]': userId, sort: 'name' },
			});
			this.billingAdminOrgs = data.data || [];
		} catch (e) {
			console.log(e);
		}
	}

	public async detach(id: integer) {
		const { userId } = this.$route.params;
		const role = {};
		role.action = 'detach';
		role.roleId = id;
		const response = await new UsersApi().userRoles(parseInt(userId, 10), { data: role });
		this.load();
	}

	public async detachPermission(id: number) {
		const { userId } = this.$route.params;
		const permission = {};
		permission.action = 'detach';
		permission.productId = id;
		const response = await new UsersApi().userPermission(parseInt(userId, 10), {
			data: permission,
		});
		this.products = this.products?.filter(element => element.id !== id) ?? this.products;
		new Toast().makeToast('Removed user product access successfully', 'User Permission', 'success');
	}

	public async changePermission(id: number) {
		const productId = id;
		const { userId } = this.$route.params;
		const permissions = { productId };
		try {
			const response = await new UsersApi().userPermissionChange(parseInt(userId, 10), {
				data: permissions,
			});
			// console.log(response);
		} catch (e) {
			let error;
			if (e.response) {
				error = 'permission not changed' + e.response.data.message;
				// console.log("error received response");
			} else if (e.request) {
				// console.log("no response");
				error = 'permission not changed, network Error';
			} else {
				// console.log("unknown Error");
				error = 'permission not changed, unknown Error';
			}
			// const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error changing permission', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		new Toast().makeToast('Permission Changed', 'User Permission', 'success');
		this.load();
	}

	public async loginAs(id: number) {
		const response = await new AuthApi().loginAsUrl(parseInt(id, 10));
		window.open(response.data, '_blank');
	}

	public created() {
		this.load();

		this.$watch(
			() => this.$route.params.userId,
			() => {
				this.load();
			},
		);
	}

	public async resetPassword(ui: string) {
		try {
			const response = await new AuthApi().forgotPassword({ email: this.user.email, app: ui });
			new Toast().makeToast('Email Sent', 'Reset password email', 'success');
		} catch (ex) {
			console.log(ex);
			new Toast().makeToast('Unable to send email', 'Reset password email', 'danger');
		}
	}

	public async resendVerifyEmail() {
		try {
			const { data } = await new AuthApi().resendActivation(this.user.id);
			new Toast().makeToast('Email sent', 'Activation email', 'success');
		} catch (ex) {
			console.log(ex);
			new Toast().makeToast('Unable to send email', 'Activation email', 'danger');
		}
	}
}
